import State from "../state"
import { RouterState } from "connected-react-router"

export const router = (state: State): RouterState => state.router
